import type { FC } from 'react'

import Checkbox from '@/components/Checkbox'

export interface Filter {
  onlyShowOpenWebforms: boolean
}

export const DEFAULT_FILTER: Filter = {
  onlyShowOpenWebforms: true,
}

interface Props {
  filter: Filter
  onChangeFilter: (filter: Filter) => void
}

const WebformFilter: FC<Props> = ({ filter, onChangeFilter }) => (
  <Checkbox
    label="Only show applicants with an open webform"
    checked={filter.onlyShowOpenWebforms}
    onChange={e =>
      onChangeFilter({
        ...filter,
        onlyShowOpenWebforms: e.target.checked,
      })
    }
  />
)

export default WebformFilter
